import React from "react";
import { FormattedMessage } from "react-intl";

const WorksiteTypeSelect = ({ value, worksiteTypes, onClick }) => {
  return (
    <div className={"w-full mb-6 flex flex-row flex-wrap justify-between"}>
      {worksiteTypes.map((item) => {
        const activeClasses =
          value === item.cod_worksite_type
            ? "border-2 border-black-500"
            : "border-2 border-transparent";

        return (
          <div
            key={item.id}
            className={`min-w-16 p-2 flex flex-col items-center cursor-pointer mr-2 mb-2 ${activeClasses}`}
            onClick={() => {
              onClick(item.cod_worksite_type);
            }}
          >
            <div
              className="w-16 h-16 mb-2 bg-contain bg-center relative bg-no-repeat"
              style={{
                backgroundImage: `url(${item.icon_name})`,
                height: "50px",
                width: "50px",
              }}
            />
            <p>
              <FormattedMessage id={item.cod_worksite_type} />
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default WorksiteTypeSelect;
